import { createStore } from 'vuex'
import api from '../api'

export default createStore({
  state: {
    user: {
      isAuthenticated: !!localStorage.getItem('userInfo'),
      userInfo: JSON.parse(localStorage.getItem('userInfo') || 'null')
    }
  },
  mutations: {
    SET_USER(state, userInfo) {
      state.user.userInfo = userInfo
      state.user.isAuthenticated = !!userInfo
      if (userInfo) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
      } else {
        localStorage.removeItem('userInfo')
      }
    },
    CLEAR_USER(state) {
      state.user.userInfo = null
      state.user.isAuthenticated = false
      localStorage.removeItem('userInfo')
    }
  },
  actions: {
    async login({ commit }, { username, password }) {
      try {
        const response = await api.post('/auth/login', { username, password })
        if (response.data.success) {
          commit('SET_USER', response.data.data.user)
          return { success: true }
        }
        return { success: false, message: response.data.message }
      } catch (error) {
        return { success: false, message: error.response?.data?.message || '登录失败' }
      }
    },
    async logout({ commit }) {
      try {
        await api.post('/auth/logout')
      } catch (error) {
        console.error('登出失败', error)
      } finally {
        commit('CLEAR_USER')
      }
    },
    async getCurrentUser({ commit }) {
      try {
        const response = await api.get('/auth/current')
        if (response.data.success) {
          commit('SET_USER', response.data.data.user)
        } else {
          commit('CLEAR_USER')
        }
      } catch (error) {
        commit('CLEAR_USER')
      }
    }
  }
})
